import { Link } from "react-router-dom";
import { FaInstagram, FaXTwitter, FaTiktok, FaYoutube, FaFacebookF } from "react-icons/fa6";

const socialIcons = {
  instagram: FaInstagram,
  twitter: FaXTwitter,
  tiktok: FaTiktok,
  youtube: FaYoutube,
  facebook: FaFacebookF,
};

export default function Footer({ settings }) {
  const socialLinks = settings?.social_links || {};

  return (
    <footer className="bg-dark-800 border-t border-dark-400">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div>
            <img
              src={settings?.logo_url || "/images/large_icon.png"}
              alt="The Slay Network"
              className="h-10 md:h-12 object-contain mb-4"
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = "none";
                if (e.target.nextElementSibling) e.target.nextElementSibling.style.display = "block";
              }}
            />
            <span className="text-xl font-extrabold bg-gradient-to-r from-primary to-green-400 bg-clip-text text-transparent block mb-4" style={{ display: "none" }}>
              THE SLAY NETWORK
            </span>
            <p className="text-sm text-gray-500 leading-relaxed max-w-[280px]">
              The Slay Network brings you a vast library of free LGTBQIA movies, tv shows, and live TV content that will enable hours and hours of pure entertainment and binge streaming.
            </p>
          </div>

          {/* Browse */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Browse</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-gray-500 hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/movies" className="text-sm text-gray-500 hover:text-primary transition-colors">Movies</Link></li>
              <li><Link to="/tvshows" className="text-sm text-gray-500 hover:text-primary transition-colors">TV Shows</Link></li>
              <li><Link to="/live-tv" className="text-sm text-gray-500 hover:text-primary transition-colors">Live TV</Link></li>
            </ul>
          </div>

          {/* Legal & Info */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Information</h4>
            <ul className="space-y-2.5">
              <li><Link to="/privacy-policy" className="text-sm text-gray-500 hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-sm text-gray-500 hover:text-primary transition-colors">Terms of Service</Link></li>
              <li><Link to="/copyright" className="text-sm text-gray-500 hover:text-primary transition-colors">Copyright</Link></li>
              <li><Link to="/advertising-policy" className="text-sm text-gray-500 hover:text-primary transition-colors">Advertising Policy</Link></li>
              <li><Link to="/cookies-policy" className="text-sm text-gray-500 hover:text-primary transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Support</h4>
            <ul className="space-y-2.5">
              <li><Link to="/feedback" className="text-sm text-gray-500 hover:text-primary transition-colors">Feedback</Link></li>
            </ul>

            {/* Play Store */}
            {settings?.playstore_url && (
              <a
                href={settings.playstore_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-5 px-4 py-2.5 bg-dark-900 border border-dark-400 rounded-lg hover:border-white/30 transition-all"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-white">
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302-2.302 2.302-2.698-2.302 2.698-2.302zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
                </svg>
                <div>
                  <p className="text-[0.6rem] text-gray-400 uppercase">Get it on</p>
                  <p className="text-sm font-semibold text-white -mt-0.5">Google Play</p>
                </div>
              </a>
            )}
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-dark-400 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-600">
            &copy; {new Date().getFullYear()} The Slay Network. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {Object.entries(socialLinks).map(([platform, url]) => {
              const Icon = socialIcons[platform];
              return Icon && url ? (
                <a
                  key={platform}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-primary transition-colors"
                  aria-label={platform}
                >
                  <Icon size={18} />
                </a>
              ) : null;
            })}
          </div>
        </div>
      </div>
    </footer>
  );
}
